/* eslint-disable */
import { Model } from '@vuex-orm/core'

class CTTNetWorkShop extends Model {
  static fields() {
    return {
      id: this.string(),
      name: this.string(),
      image: this.string(),
      code: this.string(),
      phone: this.string(),
      taxId: this.string(),
      address: this.string(),
      qrCode: this.string(),
      postcode: this.number(),
      verified: this.boolean(),
      type: this.attr(),
      subDistrict: this.attr(),
      district: this.attr(),
      province: this.attr(),
      region: this.attr(),
      area: this.attr(),
      owner: this.attr(),
      createdAt: this.attr(),
      updatedAt: this.attr(),
    }
  }

  static list(options = {}) {
    return this.api().request({
      method: 'GET',
      url: `/chang-tt/event/user`,
      ...options,
    }).then((res) => res.response.data)
  }

  static unlink (options = {}) {
    return this.api().request({
      method: 'POST',
      url: `/chang-tt/event/user/unlink`,
      ...options,
    }).then((res) => res.response)
  }
}

CTTNetWorkShop.entity = 'networkShop'

export default CTTNetWorkShop